import React from 'react';

const Footer = ({ scrollToSection, servicesRef, whatWeDoRef, contact, ach }) => {
  return (
    <footer className="w-full bg-black text-orange-700">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-12 gap-8 py-14 lg:grid-cols-8 text-orange-700">
          
          {/* Logo */}
          <div className="mb-0 col-span-full lg:col-span-3 flex justify-center lg:justify-start">
            <a href="/">
              <img
                className="w-48 h-48 rounded-full object-cover border-2 border-orange-700 shadow-lg"
                src="/logo.jpg"
                alt="Company Logo"
              />
            </a>
          </div> 
          
          {/* Get In Touch */}
          <div className="w-full text-center lg:w-auto lg:text-left col-span-full sm:col-span-4 md:col-span-4 lg:col-span-2">
            <h4 className="text-lg text-orange-700 font-medium mb-7">Get In Touch</h4>
            <ul className="text-orange-700 transition-all duration-500">
              <li className="mb-6">mindspark.revolutions@gmail.com</li>
              <li className="mb-6">
                +91 9345511498,<br />
                +91 7339491375,<br />
                +91 9080350032
                </li>
              <li>SMRV Road, Vadasery, Nagercoil</li>
            </ul>
          </div>

          {/* Products / Links */}
          <div className="w-full text-center lg:w-auto lg:text-left col-span-full sm:order-last sm:col-span-4 md:col-span-4 lg:order-none lg:col-span-1">
            <h4 className="text-lg text-orange-700 font-medium mb-7">Products</h4>
            <ul className="text-orange-700 transition-all duration-500">
              <li className="mb-6">
                <a href="javascript:;" onClick={() => scrollToSection(servicesRef)} className="text-orange-700 hover:text-gray-900">
                  Services
                </a>
              </li>
              <li className="mb-6">
                <a href="javascript:;" onClick={() => scrollToSection(whatWeDoRef)} className="text-orange-700 hover:text-gray-900">
                  About
                </a>
              </li>
              <li className="mb-6">
                <a href="javascript:;" onClick={() => scrollToSection(contact)} className="text-orange-700 hover:text-gray-900">
                  Contact
                </a>
              </li>
              <li className="sm:mb-6">
                <a href="javascript:;" onClick={() => scrollToSection(ach)} className="text-orange-700 hover:text-gray-900">
                  Achievements
                </a>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div className="w-full text-center lg:w-auto lg:text-left col-span-full sm:col-span-4 md:col-span-4 lg:col-span-2">
            <h4 className="text-lg text-center text-orange-700 font-medium mb-7 lg:text-left">Newsletter</h4>
            <div className="flex flex-col items-center lg:items-start">
              <input
                type="text"
                className="w-full h-12 border border-orange-700 rounded-full py-2.5 px-5 shadow-sm text-orange-700 mb-5 text-center lg:text-left placeholder:text-orange-700 focus:outline-none focus:border-orange-700"
                placeholder="Your email here.."
              />
              <button
                type="submit"
                className="h-11 py-3 px-6 bg-orange-700 transition-all duration-500 shadow-md rounded-full text-sm text-black font-semibold w-fit hover:bg-black hover:text-orange-700"
              >
                Subscribe
              </button>
            </div>
          </div>

        </div>
      </div>
    </footer>
  );
};

export default Footer;
